<template>
  <div class="absolute right-[75px] bg-g0 flex flex-col p-4 z-50 shadow-2xl w-[220px] bottom-[35px]" ref="tempref">
    <div class="mb-3" v-for="item in mapElementCat" :key="'keyCatMapElem_' + item.key">
      <div class="inline-flex items-center space-x-4 cursor-pointer"
        @click.stop.prevent="changeVisCat(item, !item.checked)">
        <label :for="'projecttree_cat_' + item.key">
          <span class="relative">
            <input type="checkbox" class="hidden peer" :id="'projecttree_cat_' + item.key" v-model="item.checked" />
            <div class="w-7 h-4 rounded-full shadow-inner bg-error peer-checked:bg-success"></div>
            <div
              class="absolute inset-y-0 left-0 w-2 h-2 m-1 rounded-full shadow peer-checked:right-0 peer-checked:left-auto bg-white">
            </div>
          </span>
        </label>
        <label>{{ item.name }}</label>
      </div>
      <div v-for="child in item.children" :key="'keySubCatMapElem_' + child.key" style="margin: 5px 0 5px 20px">
        <div class="flex flex-row items-center cursor-pointer" :class="isEnable(child.key) ? '' : 'itmDisable'"
          @click.stop="changeVisSubcat(child, !child.checked, true)">
          <input type="checkbox" class="chkCustomStyle" :id="'projecttree_subcat_' + child.key"
            :name="'projecttree_subcat_' + item.key" v-model="child.checked" />
          <label class="flex w-[50px] h-[30px] justify-center" v-html="child.htmlIcon"></label>
          <label>{{ child.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Map from "@/utils/Map";
import { Category_Elems } from "@/utils/constant/settings_constantes";


export default {
  name: "Map_ProjectTree",
  setup() {
    return {
      mapElementCat: ref(Category_Elems),
      nbItmCatStatic: ref(null),
      nbItmCatDyn: ref(null),

      keySubCatCurrent: ref(""),

      clickevent: ref(null),
      tempref: ref(null),
    };
  },

  watch: {
    "$root.global.statsDynamicElements"(newvalues) {
      if (newvalues) {
        this.nbItmCatDyn = newvalues;
      }
    },

    "$root.global.statsStaticElements"(newvalues) {
      if (newvalues) {
        this.nbItmCatStatic = newvalues;
      }
    },
  },

  mounted() {
    this.nbItmCatDyn = this.$root.global.statsDynamicElements;
    this.nbItmCatStatic = this.$root.global.statsStaticElements;

    this.clickevent = document.addEventListener("click", (e) => {
      if (e.target == this.tempref) return;

      let parrent = e.target.parentElement;
      for (let i = 0; i < 100; i++) {
        if (parrent == this.tempref) return;
        if (parrent == undefined) i = 100;
        parrent = parrent?.parentElement;
      }

      this.$emit("close");
    })
  },

  unmounted() {
    document.removeEventListener("click", this.clickevent)
  },

  methods: {
    changeVisCat(itm, checked) {
      itm.checked = checked;

      itm.children.forEach((child) => {
        this.changeVisSubcat(child, itm.checked, false);
      });

      this.save();
    },

    changeVisSubcat(itm, checked, save) {
      itm.checked = checked;
      Map.element.dynamicmapelements.updateLstVisible(itm.key, checked);
      Map.element.staticmapelements.setVisible(itm.key, checked);

      if (save) this.save();
    },

    isEnable(key) {
      if (this.nbItmCatStatic) {
        if (Object.keys(this.nbItmCatStatic).indexOf(key) > -1) {
          return this.nbItmCatStatic[key] > 0 ? true : false;
        }
      }
      if (this.nbItmCatDyn) {
        if (
          this.nbItmCatDyn &&
          Object.keys(this.nbItmCatDyn).indexOf(key) > -1
        ) {
          return this.nbItmCatDyn[key] > 0 ? true : false;
        }
      }
      return false;

    },

    save() {
      let data = {};

      this.mapElementCat.forEach((cat) => {
        data[cat.key] = cat.checked;

        if (cat?.children) {
          cat.children.forEach((subcat) => {
            data[subcat.key] = subcat.checked;
          });
        }
      });

      $root.user.setMapFilter(data);
    }
  },
};
</script>
